export const INCENTIVE_PARAM = 'INCENTIVE';
export const CATEGORY_ALL_ID = 'ALL';
export const CATEGORY_ALL_LABEL = 'All';
export const TOP_OFFERS_FOR_YOU_ID = 'top offers for you';

export const INLINE_ALERT_IDS = {
  PENDING_ALERT: 'pending',
  CONVENIENCE_STORE_ALERT: 'convenience-store',
  BOOST_ALERT: 'boost',
};

export const PROMO_CARD_IDS = {
  PROMO_CARD_BOOST: 'promo-card-boost',
};
